import type { AddSnackBar } from '@usealloy/component-library';

/**
 * Creates a copy-to-clipboard handler that shows success/error snackbars.
 * @param addSnackBar - From useSnackBar()
 * @returns A function ({ text, successMessage, errorMessage? }) => () => void.
 *          Pass the returned function as onClick: copyToClipboard(text, successMessage)
 */
export function createCopyToClipboardHandler(
  addSnackBar: AddSnackBar,
) {
  return ({
    text,
    successMessage,
    errorMessage = 'Failed to copy to clipboard',
  }: {
    text: string;
    successMessage: string;
    errorMessage?: string;
  }) => () => {
    navigator.clipboard.writeText(text)
      .then(() => {
        addSnackBar({
          title: successMessage,
          type: 'success',
        });
      })
      .catch(() => {
        addSnackBar({
          title: errorMessage,
          type: 'danger',
        });
      });
  };
}

export function downloadFileFromBlob(blob: Blob, filename: string) {
  // Create a temporary download link
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;

  link.download = filename;

  // Trigger download
  document.body.appendChild(link);
  link.click();

  // Cleanup
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
